/**
 * @module store/settings/mutations
 *
 * @version 1.0.0
 * @copyright SBC 2019
 */


import * as types from '@/store/mutation-types';

/* eslint-disable no-param-reassign */
export default {
  /**
   * Mutation: Установка настроек приложения
   *
   * @since Version 1.0.0
   */
  [types.SET_SETTINGS](state, settings) {
    state.settings = settings;
  },
};
/* eslint-enable no-param-reassign */
